// design/024 — browse-catalog ordering. Un-enrolled items appear first,
// sorted by createdAt desc; enrolled/joined items fall to the bottom in
// the same createdAt-desc order. Same helper is used for Courses/
// Practices (flag: "enrolled") and Groups/Events (flag: "joined").
//
// Decided 2026-10-02 — anything showing the NEW badge (created in the last
// 7 days, not a draft) goes to the very top, joined or not.
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
function isNewItem(x) {
  if (!x?.createdAt || x.draft) return false;
  const t = new Date(x.createdAt).getTime();
  return !Number.isNaN(t) && Date.now() - t < WEEK_MS;
}

export function unenrolledFirst(items, flag = 'enrolled') {
  const arr = Array.isArray(items) ? [...items] : [];
  arr.sort((a, b) => {
    const aNew = isNewItem(a);
    const bNew = isNewItem(b);
    if (aNew !== bNew) return aNew ? -1 : 1;
    const aOn = !!a?.[flag];
    const bOn = !!b?.[flag];
    if (!aNew && aOn !== bOn) return aOn ? 1 : -1;
    const at = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bt = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
    return bt - at;
  });
  return arr;
}
